import { useQuery } from '@apollo/client';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import LayersSvg from 'images/v5/icons/layers-two-01.svg';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import FormSaveActions from 'layout/molecules/FormSaveActions/FormSaveActions';
import { selectVariantsStatus } from 'store/componentDetailsSlice';
import { closeModal } from 'store/layoutSlice';
import AddVariant from './AddVariant/AddVariant';
import EditVariant from './EditVariant/EditVariant';
function ComponentVariantEditor({ type = 'add', data }) {
    var _a, _b;
    const { t } = useTranslation(['specification', 'common']);
    const { data: tenant } = useQuery(GET_CURRENT_TENANT);
    const [trigger, setTrigger] = useState(0);
    const [validationState, setValidationState] = useState({
        isValid: false,
        pendingFields: [],
    });
    const dispatch = useDispatch();
    const variantsStatus = useSelector(selectVariantsStatus);
    const tenantId = (_b = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.me) === null || _a === void 0 ? void 0 : _a.currentTenant) === null || _b === void 0 ? void 0 : _b.id;
    const handleValidationChange = useCallback(({ isValid, pendingFields, validateAll }) => {
        setValidationState({ isValid, pendingFields, validateAll });
    }, []);
    const handleFormSubmit = () => {
        setTrigger((t) => t + 1);
        return true;
    };
    const handleCreatorClose = () => {
        dispatch(closeModal({ name: type === 'add' ? 'variantCreator' : 'variantEdit' }));
    };
    let header;
    let content;
    switch (type) {
        case 'add':
            header = t('common:new_variant');
            content = (React.createElement(AddVariant, { trigger: trigger, data: data === null || data === void 0 ? void 0 : data.item, tenantId: tenantId, onClose: () => { }, onValidationChange: handleValidationChange }));
            break;
        case 'edit':
            header = t('specification:edit_variant');
            content = (React.createElement(EditVariant, { trigger: trigger, data: data, onClose: () => { }, onValidationChange: handleValidationChange }));
            break;
        default:
            header = t('common:new_variant');
            content = (React.createElement(AddVariant, { trigger: trigger, tenantId: tenantId, onClose: () => { }, onValidationChange: handleValidationChange }));
    }
    return (React.createElement(Modal, { name: type === 'add' ? 'variantCreator' : 'variantEdit', size: "s", header: React.createElement(Label, { weight: "strong" },
            React.createElement(LayersSvg, null),
            " ",
            header), footer: React.createElement(FormSaveActions, { isValid: validationState.isValid, isLoading: type === 'add'
                ? (variantsStatus === null || variantsStatus === void 0 ? void 0 : variantsStatus.add) === 'loading'
                : (variantsStatus === null || variantsStatus === void 0 ? void 0 : variantsStatus.update) === 'loading', pendingFields: validationState.pendingFields, onSave: handleFormSubmit, onCancel: handleCreatorClose, validateAll: handleFormSubmit }) },
        React.createElement("div", null, content)));
}
export default ComponentVariantEditor;
